module.exports = __webpack_public_path__ + "img/o-first.905b19e6.svg";